import React from "react";
import ReactDOMServer from "react-dom/server";
import "../App.css";
import axios from "axios";
import { Link } from "react-router-dom";
const HtmlToReactParser = require("html-to-react").Parser;

class Articles extends React.Component {
  state = {
    blogPosts: [
      {
        id: 0,
        title: { rendered: "" },
        excerpt: { rendered: "" },
        content: { rendered: "" }
      }
    ],
    comments: [
      {
        author_name: "",
        content: { rendered: "" },
        author_avatar_urls: { 48: "" },
        date: ""
      }
    ],
    postID: this.props.postID || false,
    renderComments: false
  };
  componentDidMount() {
    if (this.state.postID === false) {
      axios
        .get(`${this.props.WPConfig.siteURL}wp-json/wp/v2/posts`)
        .then(res => res.data)
        .then(blogPosts => {
          this.setState({
            blogPosts: blogPosts
          });
        });
    } else {
      axios
        .get(
          `${this.props.WPConfig.siteURL}wp-json/wp/v2/posts/?include[]=${this.state.postID}`
        )
        .then(res => res.data)
        .then(blogPosts => {
          this.setState({
            blogPosts: blogPosts
          });
        });
      axios
        .get(
          `${this.props.WPConfig.siteURL}wp-json/wp/v2/comments/?post=${this.state.postID}`
        )
        .then(res => res.data)
        .then(comments => {
          this.setState({
            comments: comments
          });
        });
    }
  }
  reactParse = parse => {
    let HTMLToReactParser = new HtmlToReactParser();
    let reactElement = HTMLToReactParser.parse(parse);
    return ReactDOMServer.renderToStaticMarkup(reactElement);
  };
  parseDate = date => {
    let y = date.substring(0, 4);
    let m = date.substring(5, 7);
    let d = date.substring(8, 10);
    let h = date.substring(11, 13);
    let min = date.substring(14, 16);
    return `${h}:${min} ${d}/${m}/${y}`;
  };
  render() {
    let render = [];
    this.state.blogPosts.forEach((blogPost, index) => {
      let title = this.reactParse(blogPost.title.rendered);
      let body =
        this.state.postID === false
          ? this.reactParse(blogPost.excerpt.rendered)
          : this.reactParse(blogPost.content.rendered);
      if (this.state.postID === false) {
        body = body.substring(0, body.length - 9) + "...</p>";
      }
      let className = this.state.postID === false ? "collapsed" : "open";
      render.push(
        <article key={index} className={className}>
          <Link to={"/post/" + blogPost.id} className="articleLink">
            <h3
              dangerouslySetInnerHTML={{
                __html: title
              }}
            ></h3>
          </Link>
          <div
            className="body"
            dangerouslySetInnerHTML={{
              __html: body
            }}
          ></div>
        </article>
      );
    });
    if (this.state.postID !== false && this.state.comments.length >= 1) {
      if (this.state.comments.length === 1) {
        render.push(<h4>1 Comment</h4>);
      } else {
        render.push(<h4>{this.state.comments.length} Comments</h4>);
      }
      this.state.comments.forEach((comment, index) => {
        let name = comment.author_name;
        let body = this.reactParse(comment.content.rendered);
        let date = this.parseDate(comment.date);
        let img = comment.author_avatar_urls[48];
        render.push(
          <div className="comment">
            <div className="comment-header">
              <img src={img} alt="Comment avatar" />
              <strong className="comment-username">{name}</strong>
            </div>

            <div
              className="comment-body"
              dangerouslySetInnerHTML={{ __html: body }}
            />
            <i className="comment-date">{date}</i>
          </div>
        );
      });
    }
    return <main>{render}</main>;
  }
}

export default Articles;
